import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../services/api.service';

const SUSPENDED_ACCOUNT_STATUS = 'SUSPENDED';

@Component({
  selector: 'app-account-suspended-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './account-suspended-banner.component.html',
})
export class AccountSuspendedBannerComponent implements OnInit {
  @Input() isDarkMode = false;

  suspended = false;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loadStatus();
  }

  private async loadStatus(): Promise<void> {
    try {
      const profile = await this.apiService.getAccountProfile();
      this.suspended = String(profile?.status ?? '').trim().toUpperCase() === SUSPENDED_ACCOUNT_STATUS;
    } catch (error) {
      console.error('Could not read account status', error);
      this.suspended = false;
    }
  }
}
